import { render, staticRenderFns } from "./Basket.vue?vue&type=template&id=5f06325e&scoped=true"
import script from "./Basket.vue?vue&type=script&lang=js"
export * from "./Basket.vue?vue&type=script&lang=js"
import style0 from "./Basket.vue?vue&type=style&index=0&id=5f06325e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f06325e",
  null
  
)

export default component.exports